export function get_option_deduct(data) {
    let option = {
        title: {
            top: "3",
            left: "center",
            text: "近3年的月度发票（进项）抵扣情况折线图",
            subtext: ""
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: ['抵扣金额'],
            top: 60
        },
        grid: {
            top: 90,
            show: true
        },
        toolbox: {
            feature: {
                dataView: {
                    show: true,
                    readOnly: false
                },
                magicType: {
                    show: true,
                    type: ['line', 'bar']
                },
                restore: {
                    show: true
                },
                saveAsImage: {}
            }
        },

        dataset: [{
            source: data
        }],
        xAxis: {
            type: 'category',
            boundaryGap: false
        },
        yAxis: [{
                type: 'value',
                name: '金额(元)',
                nameLocation: "middle",
                nameGap: 50
            },

        ],
        series: [{
                name: '抵扣金额',
                type: 'line',
                smooth: false,
                encode: {
                    x: 'ym',
                    y: 'totalAmount'
                }
            },
            // {
            //     name: 'N₂O',
            //     type: 'line',
            //     smooth: true,
            //     encode: {
            //         x: 'time_of_data',
            //         y: 'N2O'
            //     },
            //     yAxisIndex: 1,
            // },

        ]
    };
    return option;
}


